module.exports = __webpack_public_path__ + "static/media/36-14.b1561c8c.mp3";